<div class="app">
    <div>
        <app-navigation />
    </div>

    <div class="app-shell-content">
        <router-outlet />
    </div>
</div>
